import {
  Component,
  Input,
  OnInit,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { HttpParams } from "@angular/common/http";
import { CarrierRepository } from "../../../carrier/carrier.repository";
import { Carrier } from "../../../carrier/carrier.model";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface CarrierChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-carrier-select",
  styleUrls: ["./carrier-select.component.scss"],
  templateUrl: "./carrier-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class CarrierSelectComponent implements OnInit {
  private carrierRepository = inject(CarrierRepository);

  public readonly carrierChange = output<string>();
  @Input() public carrier: Carrier;
  public readonly kind = input<string[]>(undefined);
  public readonly options = input<SelectItem[]>(undefined);
  public readonly disabled = input(false);
  public readonly required = input(false);
  public readonly showAll = input(true);
  @Input() public label: string;

  public subscription = new Subscription();
  public carrierList: SelectItem[] = [];

  ngOnInit() {
    this.buildCarrierList();
  }

  public onCarrierChange(event: CarrierChangeEvent) {
    this.carrierChange.emit(event.value);
  }

  private buildCarrierList(): void {
    this.carrierList = [];
    if (this.showAll()) {
      this.carrierList.push({ label: "All", value: null });
    }
    const options = this.options();
    if (options) {
      this.carrierList = [...this.carrierList, ...options];
    } else {
      let params = new HttpParams();
      const kind = this.kind();
      if (kind) {
        const filteredKind = kind.filter(function (el) {
          return el != null;
        });
        if (!!filteredKind && filteredKind.length) {
          params = params.append("criteria[kind]", filteredKind.join(","));
        }
      }

      this.carrierRepository.list(params).subscribe((carrierList) => {
        carrierList.forEach((carrier) => {
          this.carrierList.push({ label: carrier.getName(), value: carrier });
        });
      });
    }
  }
}
